import { useEffect, useRef, useState } from "react";
import CameraPermission from "../../components/CameraPermission/CameraPermission";
const TorchShow = ({ animationDuration = 1 }) => {
  const timeoutIdFOrOn = useRef(null);
  const timeoutIdFOrOff = useRef(null);
  const [cameraStream, setCameraStream] = useState(null);
  const [isOn, setIsOn] = useState(false);
  const [camState, setCamState] = useState(null);
  const init = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });
      const track = stream.getVideoTracks()[0];
      const capabilities = track.getCapabilities();

      if (capabilities.torch) {
        await track.applyConstraints({
          advanced: [{ torch: true }],
        });
        setIsOn(true);
        setCameraStream(stream);
      } else {
        console.log("Torch not available");
      }
    } catch (err) {
      console.error("Error accessing torch:", err);
      //setMessage("Error accessing torch");
    }
  };
  useEffect(() => {
    return () => {
      if (cameraStream) {
        cameraStream.getVideoTracks().forEach((track) => {
          track
            .applyConstraints({
              advanced: [{ torch: false }],
            })
            .then(() => {
              track.stop();
            });
        });
      }
    };
  }, []);

  const switchOff = () => {
    if (cameraStream) {
      const track = cameraStream.getVideoTracks()[0];
      track.applyConstraints({
        advanced: [{ torch: false }],
      });
      setIsOn(false);
    }
  };
  const switchOn = () => {
    if (cameraStream) {
      const track = cameraStream.getVideoTracks()[0];
      track.applyConstraints({
        advanced: [{ torch: true }],
      });
      setIsOn(true);
    }
  };
  useEffect(() => {
    if (animationDuration === 0) {
      clearTimeout(timeoutIdFOrOn.current);
      clearTimeout(timeoutIdFOrOff.current);
      switchOn();
      return;
    }
    if (isOn) {
      clearTimeout(timeoutIdFOrOn.current);
      timeoutIdFOrOff.current = setTimeout(switchOff, animationDuration * 1000);
    } else {
      clearTimeout(timeoutIdFOrOff.current);
      timeoutIdFOrOn.current = setTimeout(switchOn, animationDuration * 1000);
    }
    return () => {
      clearTimeout(timeoutIdFOrOff.current);
      clearTimeout(timeoutIdFOrOn.current);
    };
  }, [isOn, animationDuration]);

  return camState !== "granted" ? (
    <CameraPermission
      onPermissionGranted={() => {
        setCamState("granted");
        init();
      }}
    />
  ) : null;
};
export default TorchShow;
